import { graphql } from 'gatsby';
import React from 'react';
import PropTypes from 'prop-types';

import BrandFeature from '~/components/blocks/acf/BrandFeature';

import { AcfLink } from '~/utilities/propTypes';

const BrandFeatureBlock = ({
    attributes,
    globalBlockOptions: { globalBlockOptions },
    blockBrandFeature
}) => (
    <BrandFeature
        {...{
            ...blockBrandFeature,
            globalBlockOptions,
            attributes
        }}
    />
);

BrandFeatureBlock.propTypes = {
    blockBrandFeature: PropTypes.shape({
        highlights: PropTypes.arrayOf(
            PropTypes.shape({
                highlight: PropTypes.string
            })
        ).isRequired,
        ctas: PropTypes.arrayOf(
            PropTypes.shape({
                link: AcfLink
            })
        ),
        images: PropTypes.arrayOf(
            PropTypes.shape({
                image: PropTypes.shape({})
            })
        ).isRequired
    }).isRequired
};

export default BrandFeatureBlock;

export const fragment = graphql`
    fragment BrandFeatureBlockFragment on WpAcfBrandFeatureBlock {
        name
        attributes {
            anchor
            className
        }
        globalBlockOptions {
            globalBlockOptions {
                marginBottom
            }
        }
        blockBrandFeature {
            highlights {
                highlight
            }
            ctas {
                link {
                    url
                    title
                }
            }
            images {
                image {
                    altText
                    sourceUrl
                    localFile {
                        childImageSharp {
                            gatsbyImageData
                        }
                    }
                }
            }
        }
    }
`;

export const exampleData = [
    {
        variant: 'Default Brand Feature',
        description:
            'Images will be displayed top to bottom. The last 2 images will be displayed on mobile views. Maximum 5 images. Recommended Image Sizes (top to bottom): 1. Aspect Ratio 1.5, Minimum Size (px) 430x290 2. Aspect Ratio 1.5, Minimum Size (px) 470x315 3. Aspect Ratio .73, Minimum Size (px) 330x450 4. Aspect Ratio 1, Minimum Size (px) 330x330 5. Aspect Ratio 1.5, Minimum Size (px) 500x335',
        props: {
            name: 'acf/brand-feature',
            blockBrandFeature: {
                highlights: [
                    {
                        highlight:
                            "Whole car, not half. That's the Autobell difference."
                    },
                    {
                        highlight:
                            'You can think of us as a full-service car wash in a self-service world. '
                    },
                    {
                        highlight:
                            'We clean your whole car, outside and inside, and we do it with a human touch. '
                    },
                    {
                        highlight:
                            'Our full-service clean is our charm, the foundation fora better way to wash your car, and the convenience you know you need.'
                    }
                ],
                ctas: [
                    {
                        link: {
                            title: 'Learn More',
                            url: '#',
                            target: ''
                        }
                    }
                ],
                images: [
                    {
                        image: {
                            sourceUrl: 'https://picsum.photos/430/290'
                        }
                    },
                    {
                        image: {
                            sourceUrl: 'https://picsum.photos/470/315'
                        }
                    },
                    {
                        image: {
                            sourceUrl: 'https://picsum.photos/240/330'
                        }
                    },
                    {
                        image: {
                            sourceUrl: 'https://picsum.photos/330'
                        }
                    },
                    {
                        image: {
                            sourceUrl: 'https://picsum.photos/500/335'
                        }
                    }
                ]
            }
        }
    }
];
